/**
 * Runtime version identity for About UI (Electron IPC or Vite/browser env).
 */

export type AppVersionInfo = {
  app: "desktop-v2" | "premier";
  version: string;
  gitSha: string;
  builtAt: string;
  buildId: string;
  channel: string;
};

function shortSha(gitSha: string): string {
  return gitSha === "dev" ? "dev" : gitSha.slice(0, 7);
}

export function formatVersionLabel(info: Pick<AppVersionInfo, "version" | "gitSha">): string {
  return `${info.version} (${shortSha(info.gitSha)})`;
}

/** Browser / Premier SPA: values baked by Vite `define`. */
export function readBrowserVersionInfo(): AppVersionInfo {
  const env = import.meta.env as Record<string, string | undefined>;
  const version = env.VITE_APP_VERSION || "0.0.0";
  const gitSha = env.VITE_GIT_SHA || "dev";
  const builtAt = env.VITE_BUILT_AT || "";
  const buildId = env.VITE_BUILD_ID || `${version}+${shortSha(gitSha)}`;
  const channel = env.VITE_APP_CHANNEL || (env.VITE_PREMIER === "1" ? "production" : "dev");
  const app = env.VITE_PREMIER === "1" ? "premier" : "desktop-v2";
  return { app, version, gitSha, builtAt, buildId, channel };
}
